<template>
    <div class="object-block-generic"></div>
</template>

<script>
import { getOverviewPathFromType } from 'Dictionaries/overviewPath.js';
import { OBJECT_BLOCK_VARIANT } from 'Dictionaries/commonComponents/ObjectBlockEnums';
import BlockName from 'vcomponents/common/object/BlockName.vue';

export default {
    components: { BlockName },
    props: {
        data: {
            type: Object,
            required: true,
        },
        variant: {
            type: String,
            default: OBJECT_BLOCK_VARIANT.PREVIEW,
        },
        isIncluded: {
            type: Boolean,
            default: false,
        },
        showLink: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            OBJECT_BLOCK_VARIANT,
            linkCard: null,
            objectCaption: '',
        };
    },
    computed: {
        displayDescriptionList() {
            return [
                OBJECT_BLOCK_VARIANT.PREVIEW,
                OBJECT_BLOCK_VARIANT.OVERVIEW,
                OBJECT_BLOCK_VARIANT.LINKED,
            ].includes(this.variant);
        },
        objectBlockClasses() {
            return [
                'object-block',
                `object-block--${this.variant}`,
                this.isIncluded ? 'object-block--included' : '',
            ];
        },
        hasSlotCompany() {
            return !!this.$slots.company;
        },
        hasSlotContact() {
            return !!this.$slots.contact;
        },
    },
    methods: {
        getObjectId() {
            let id = this.data.id;
            if (this.data.object && this.data.object instanceof Object) {
                id = this.data.object.id;
            }
            return id;
        },
        getLink({ id, type, subtype = '' }) {
            return getOverviewPathFromType({ type, id, subtype });
        },
    },
};
</script>

<style lang="scss">
.object-block {
    background-color: var(--colors-common-background-default);

    &--preview {
        &.object-block--empty {
            background-color: var(--colors-common-background-subtle);
            border: 1px solid var(--colors-common-border-lighter);
            border-radius: var(--spacing-1);
            padding: var(--spacing-3);
        }
    }

    &--linked {
        border: 1px solid var(--colors-common-border-lighter);
        border-radius: var(--spacing-1);
        padding: var(--spacing-3);
    }

    &--embedded {
        width: 100%;
    }

    &--overview {
        .object-block__related-container {
            padding: var(--spacing-2);
            display: flex;
            flex-direction: column;
            gap: var(--spacing-2);
        }
        .object-block__header {
            gap: var(--spacing-1);
        }
        & > .object-block__main {
            display: flex;
            flex-direction: column;
            background-color: var(--colors-common-background-subtle);
            padding: var(--spacing-2);
            border-radius: var(--spacing-1);
        }
    }

    .object-block__header {
        align-items: flex-start;
        display: flex;
        gap: var(--spacing-4);
        justify-content: space-between;

        a {
            flex-shrink: 0;
        }

        &-title-container {
            align-items: center;
            display: flex;
            gap: var(--spacing-1);
            &:has(.object-block__header-name:hover) {
                .compass-object {
                    position: relative;
                    &::after {
                        content: '';
                        background: var(--colors-common-background-colored-hover);
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        border-radius: var(--spacing-0);
                    }
                }
            }
        }

        &-name-container {
            align-items: center;
            display: flex;
            gap: var(--spacing-1);
        }
        &-name {
            -webkit-box-orient: vertical;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
        }

        &-caption {
            color: var(--colors-common-text-standard-caption);
        }
        &-actions {
            display: flex;
            flex-shrink: 0;
            gap: var(--spacing-3);
        }
    }
}
</style>
